import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StateService, AuthService} from '../../service';
import {TranslateService} from '@ngx-translate/core';
import {UserModel} from '../../models';
import {MENU_CONFIG} from '../../const/menu-config';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {

  isSidebarOpen: boolean = false;
  appToken: string;
  menuConfig: {}[];

  constructor(private router: Router,
              private userService: AuthService,
              private translate: TranslateService,
              private stateService: StateService) {

    this.stateService.sideMenuState.subscribe((state) => {
      this.isSidebarOpen = state;
    });

    this.configureMenu();

  }

  ngOnInit() {

    this.stateService.setSelectedSideMenuState(false);
    this.userService.token.subscribe(
      (token) => {
        this.appToken = token;
      }
    );
  }


  toggleSideBar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.stateService.setSelectedSideMenuState(this.isSidebarOpen);
  }

  openPage(menu) {
    this.router.navigateByUrl(menu.route);
  }

  configureMenu() {
    this.menuConfig = MENU_CONFIG;
  }
}
